import type { IconProps } from '../types/IconProps.ts';
export const Briefcase: IconProps = {
    name: 'Briefcase',
    children: [
        `<rect width="20" height="14" x="2" y="6" rx="2" />`,
        `<path d="M8 20V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v16" />`,
    ]
};